import { findAncestor } from '@helpers/findAncestor';
import { trackCheckoutStep, isCheckoutStepPushed } from '../helpers/GATrackCheckoutStep';

const BILLING_INFO_FORM_ID = 'billing_info';
const CHECKOUT_FORM_ID = 'checkout_form';
const ORDER_INSTABOX_ID = 'order_Instabox_box';

export const defaultCheckoutTrackConfig = {
    init: () => {},
    handleSubmit: (e) => {
        const { id } = e.target;

        if (id === CHECKOUT_FORM_ID) {
            if (isCheckoutStepPushed('step 1')) {
                trackCheckoutStep(5);
            } else {
                trackCheckoutStep(5, 'default');
            }
        }
    },
    initClickHandlers: (e) => {
        if (!defaultCheckoutTrackConfig.hasBillingTrackedOnce) {
            const billingInfoBox = findAncestor(e.target, BILLING_INFO_FORM_ID);
            const isInputOrSelect = e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT';

            if (isInputOrSelect && billingInfoBox) {
                trackCheckoutStep(2);
                defaultCheckoutTrackConfig.hasBillingTrackedOnce = true;
            }

            return;
        }

        // Avoid calling twice on a count of custom radio button
        const isInput = e.target.tagName === 'INPUT';

        const isPayOption = (findAncestor(e.target, 'payment-selector') || findAncestor(e.target, 'ck-choose-payment'));
        const isShipOption = (findAncestor(e.target, 'shipby-box') || findAncestor(e.target, 'shipping-info'));
        const isShopOption = (findAncestor(e.target, 'parcel_shop_slot') || findAncestor(e.target, 'pakkeshop_list'));

        if (isInput) {
            if (isPayOption) {
                trackCheckoutStep(1);
            } else if (isShipOption) {
                trackCheckoutStep(3);
            } else if (isShopOption) {
                trackCheckoutStep(4);
            }
        }

        const initInstabox = async (initEvent) => {
            const node = initEvent.target;
            const isOrderInstabox = node.id === ORDER_INSTABOX_ID;

            if (isOrderInstabox) {
                node.addEventListener('change', () => trackCheckoutStep(4), { once: true });
            }

            return isOrderInstabox;
        };

        initInstabox(e);
    },
    hasBillingTrackedOnce: false
};
